import type { IRaisedAttentionStatus } from 'partner360/entities/attentionStatuses'

/**
 * One row per status as the reader tells them apart. `Overall` decodes a status once per offering
 * that raised it; a status whose title names its offering reads as one row per offering, but one
 * that names none — `plans don't have planned MDF initiatives` — would repeat the same words, so
 * those rows are merged, keeping every offering that raised it.
 */
export const mergeSameTitledStatuses = (
  statuses: IRaisedAttentionStatus[],
  titleOf: (status: IRaisedAttentionStatus) => string
): IRaisedAttentionStatus[] => {
  const merged = new Map<string, IRaisedAttentionStatus>()

  statuses.forEach((status) => {
    const key = `${status.bitValue}|${titleOf(status)}`
    const kept = merged.get(key)

    merged.set(
      key,
      kept
        ? {
            ...kept,
            severity: Math.max(kept.severity, status.severity),
            offerings: [...new Set([...kept.offerings, ...status.offerings])],
          }
        : status
    )
  })

  return [...merged.values()]
}
